module.exports = "//static.hsappstatic.net/ui-images/static-2.759/optimized/transparent_background.svg"